import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Colors, Sizes, TextStyles} from '../index';
import {InputSearchFieldBase, InputSearchFieldProps} from './InputSearchField';

export const SurfaceSearchField = (props: InputSearchFieldProps) => {
  return (
    <View style={props.containerStyle}>
      <View style={styles.container}>
        <InputSearchFieldBase {...{...props}} textInputStyle={[TextStyles.textMediumS]} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.neutralOff,
    borderRadius: Sizes.s,
    padding: Sizes.xs,
    flexDirection: 'row',
    alignItems: 'center',
  },
});
